import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'

type DataApiClient = Omit<AxiosInstance, 'get' | 'post' | 'put' | 'patch' | 'delete'> & {
  get<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T>
  post<T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T>
  put<T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T>
  patch<T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T>
  delete<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T>
}

const envApiBaseUrl = import.meta.env.VITE_API_BASE_URL
const isLoopbackApiBase = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(envApiBaseUrl || '')
const API_BASE_URL = isLoopbackApiBase ? '/api/v1' : (envApiBaseUrl || '/api/v1')
const AUTH_EXPIRED_FLAG = 'cbms_auth_expired_redirecting'

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('cbms_token')
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Add response interceptor
axiosClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('cbms_token')

      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login/') && window.location.pathname !== '/entry') {
        if (!sessionStorage.getItem(AUTH_EXPIRED_FLAG)) {
          sessionStorage.setItem(AUTH_EXPIRED_FLAG, '1')
          window.location.replace('/login/admin?reason=expired')
        }
      }
    }

    console.error('API Error:', error)
    throw error
  }
)

const apiClient = axiosClient as DataApiClient

export default apiClient
